import React from 'react'

import { HeadingMedium, Label, BodyText } from '@pb/components'
import { useDispatch, useSelector } from 'react-redux'

import appSelectors from 'App/duck/selectors'
import { TODO_TAB } from 'features/account/hm-pay/constants'
import { setSelectedTab } from 'features/account/hm-pay/duck/actions'

import { toggleInbox } from '../../duck/actions'
import { operationMarkNotificationsAsRead } from '../../duck/operations'
import inboxSelectors from '../../duck/selectors'
import Message from '../Message'
import styles from './MessageContent.scss'

const MessageContent: React.FC<any> = ({ messages }) => {
  const dispatch = useDispatch()
  const setOmniCreditTabToTodo = (): any => dispatch(setSelectedTab(TODO_TAB.id))
  const hideInbox = (): any => dispatch(toggleInbox())

  const markNotificationsAsRead = (notificationEventIds): any =>
    dispatch(operationMarkNotificationsAsRead(notificationEventIds))
  const isLargeScreen = useSelector(appSelectors.getIsLargeScreen)
  const isAllRead = useSelector(inboxSelectors.getAreAllMessagesRead)

  return (
    <article className={styles.container}>
      <header className={styles.header}>
        {isLargeScreen && (
          <HeadingMedium className={styles.title}>
            <Label copyKey="omni.myaccount.inbox.modal.title" />
          </HeadingMedium>
        )}
        <button
          className={styles.markAllRead}
          onClick={() => {
            const allNotificationsIds = messages.map((message) => message.notificationEventId)
            markNotificationsAsRead(allNotificationsIds)
          }}
          type="button"
          disabled={isAllRead}
        >
          <BodyText>
            <Label copyKey="omni.myaccount.inbox.modal.button" />
          </BodyText>
        </button>
      </header>

      <ul>
        {messages.map((message) => (
          <Message
            key={message.notificationEventId}
            message={message}
            markMessageAsRead={() => markNotificationsAsRead(message.notificationEventId)}
            setOmniCreditTabToTodo={setOmniCreditTabToTodo}
            hideInbox={hideInbox}
          />
        ))}
      </ul>
    </article>
  )
}

export default MessageContent
